import * as React from 'react'
import { RoundBadge } from './styles'
import type { BadgeInternalProps } from './types'

const Badge = ({
  bgColor,
  className,
  description,
  fontColor,
  height,
  loading,
  margin,
  menuWidth,
  placeholder,
  position,
  title,
  showProgress,
  progress,
  openCTA,
  bottomBarColor,
  onClick: handleClick
}: BadgeInternalProps) => {
  const [hovering, setHover] = React.useState(false)
  const handleMouseEnter = () => setHover(true)
  const handleMouseLeave = () => setHover(false)

  return (
    <RoundBadge
      {...{
        bgColor,
        className,
        description,
        fontColor,
        height,
        loading,
        margin,
        placeholder,
        position,
        title,
        showProgress,
        progress,
        menuWidth,
        hovering,
        openCTA,
        bottomBarColor
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      <div>
        <div>
          <span>{placeholder}</span>
        </div>
        <div>
          <em>{title}</em>
          {description}
        </div>
      </div>
      <div>
        <div />
      </div>
    </RoundBadge>
  )
}

export default Badge
export * from './types'
